import { useState } from "react";

let idCounter = 0;

// Simple hook to return an element ID with a given prefix
//
// This should be replaced with useId once we're on React 18
export const useElementId = (prefix) => {
  const [id] = useState(() => `${prefix}-${idCounter++}`);
  return id;
};
